import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import SportArcSlider from './SportArcSlider';

const ChangeVibeModal = ({ onClose, onSave }) => {
    const { t } = useTranslation();
    const { user } = useAuth();
    const [selectedSport, setSelectedSport] = useState(user?.favorite_sport || 'football');

    const handleSave = () => {
        onSave(selectedSport);
    };

    return (
        <div className="modal-backdrop" onClick={onClose}>
            <motion.div
                className="modal-content"
                onClick={e => e.stopPropagation()}
                initial={{ scale: 0.7, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ type: "spring", stiffness: 100, damping: 20 }}
            >
                <h2 style={{marginTop: 0, textAlign: 'center', fontFamily: 'var(--font-display)'}}>{t('change_favorite_vibe_button')}</h2>

                <div style={{ minHeight: '220px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <SportArcSlider
                        onSelect={(sportKey) => setSelectedSport(sportKey)}
                        initialSportKey={user?.favorite_sport || selectedSport}
                    />
                </div>

                <div style={{display: 'flex', gap: '15px', marginTop: '30px' }}>
                    <button onClick={onClose} style={{ flex: 1 }} className="button-secondary">{t('cancel_request_button')}</button>
                    <button onClick={handleSave} style={{ flex: 1 }} className="button-primary">Save</button>
                </div>
            </motion.div>
        </div>
    );
};

export default ChangeVibeModal;
